// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__0rxXm","image":"Notification_image__IpNW4","delete":"Notification_delete__lo7qU"};